import {useIssueCreateMetadata} from '@github-ui/issue-create/IssueCreateDataContext'
import isEqual from 'lodash-es/isEqual'

import type {DraftIssue} from '../content-preview-types'
import {useDraftIssueFormSync} from './use-draft-issue-form-sync'
import {useLabelsQuery} from './use-labels-query'
import {useOnChangeCallback} from './use-on-change-callback'

export function useDraftIssueLabels(draftIssue: DraftIssue) {
  const {repository: formRepository, labels: formLabels, setLabels: setFormLabels} = useIssueCreateMetadata()
  const onChange = useOnChangeCallback(draftIssue)

  return useDraftIssueFormSync(draftIssue, {
    draftValue: draftIssue.labels,
    formValue: formLabels,
    setFormValue: setFormLabels,
    onChange: (newValue, skipVersionBump) => onChange({labels: newValue.map(l => l.name)}, skipVersionBump),
    resolverResult: useLabelsQuery({
      owner: formRepository?.owner.login,
      repo: formRepository?.name,
      labels: draftIssue.labels ?? [],
    }),
    hasPermission: repo => repo?.viewerIssueCreationPermissions?.labelable,
    isEqual,
    defaultValue: [],
  })
}
